import * as types from './types'

export default {
  [types.SET_DASHBOARD](state, data) {
    state.dashboard = data
  },
  [types.SET_CLIENTREVIEW](state, data) {
    state.dashboard = data
  },
  [types.SET_CLIENTINSPECTIONS](state, data) {
    state.dashboard = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js